import styled from 'styled-components';

interface TitlePageStyledProps {
  fontSize: number;
}

const TitlePageStyled = styled.h1<TitlePageStyledProps>`
  font-style: normal;
  font-weight: bold;
  font-size: ${({ fontSize }) => fontSize}px;
  line-height: 24px;
  color: ${({ theme }) => theme.titleColor};
`;

export default TitlePageStyled;
export { TitlePageStyled };
